// extracted by mini-css-extract-plugin
export default {"tagPill":"TagPill_tagPill__73tVy","disableLink":"TagPill_disableLink__5eSkJ"};